import React, { useCallback } from 'react'
import { useMediaQuery } from 'react-responsive'
import PropTypes from 'prop-types'
import { MasonryPhotoAlbum } from 'react-photo-album'

import SkeletonAdsGalleryItem from './AdsGalleryItem/Skeleton'

import { insertIf } from '../../../../helpers/common'

import { phonesUpWidth, tabletUpWidth } from '../../../../styles/const/breakpoints'

function SkeletonAdsGallery({ columns, showDetails, showInternalAdActionButtonsSkeleton }) {
  // we add 80px to imitate containerWidth from real gallery container by adding page paddings
  const isTabletUp = useMediaQuery({ minWidth: `${tabletUpWidth + 80}px` })
  const isPhonesUp = useMediaQuery({ minWidth: `${phonesUpWidth + 80}px` })

  // some photos are shown only on specific screen sizes to imitate gallery columns layout
  const photos = [
    {
      width: 200,
      height: 260
    },
    ...insertIf(isTabletUp, {
      width: 960,
      height: 400
    }),
    {
      width: 250,
      height: 300
    },
    ...insertIf(isPhonesUp, {
      width: 200,
      height: 260
    })
  ]

  const EnhancedSkeletonAdsGalleryItem = useCallback(
    (id, props) => (
      <SkeletonAdsGalleryItem
        showDetails={showDetails}
        showInternalAdActionButtonsSkeleton={showInternalAdActionButtonsSkeleton}
        {...props}
      />
    ),
    [showInternalAdActionButtonsSkeleton, showDetails]
  )

  return (
    <MasonryPhotoAlbum
      photos={photos}
      spacing={16}
      columns={columns}
      render={{ photo: EnhancedSkeletonAdsGalleryItem }}
    />
  )
}

SkeletonAdsGallery.propTypes = {
  columns: PropTypes.func.isRequired,
  showDetails: PropTypes.bool,
  showInternalAdActionButtonsSkeleton: PropTypes.bool
}

export default SkeletonAdsGallery
